import React from 'react';
import { Box, Flex, Icon } from '@qga/roo-ui/components';

import Heading from '@/components/Heading';
import Link from '@/components/Link';
import Text from '@/components/Text';
import useCallCentreWorkingStatus from '@/hooks/useCallCentreWorkingStatus';
import { NUMBER, SUPPORT_HOURS, TEXT } from '../contants';

const CallUs = React.memo(() => {
  const { isOpen } = useCallCentreWorkingStatus();
  return (
    <Flex alignItems="flex-start">
      <Box>
        <Icon name="call" size={[22, null, 36]} />
      </Box>
      <Flex ml="2" pt={[null, null, 2]} flexDirection="column">
        <Heading.h4>Call us</Heading.h4>
        <Text mt="2">
          Call {TEXT} for all information you need to help you book your
          holiday.
        </Text>
        <Text>
          <b>{`Available ${SUPPORT_HOURS}`}</b>. If you have a query related to
          a booking only involving a flight (does not include a Jetstar hotel)
          please{' '}
          <Link.Text href="https://www.jetstar.com/au/en/contact-us">
            contact us here
          </Link.Text>{' '}
          as the Jetstar Holidays team are unable to assist with these requests.
        </Text>
        {isOpen && (
          <Flex>
            <Link.Button
              mt="4"
              dialogue
              data-testid="CALL-US"
              href={`tel:${NUMBER}`}
            >
              {`Call ${TEXT}`}
            </Link.Button>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
});

export default CallUs;
